<style lang="scss">

</style>

<template>
	<div style="overflow: auto;height: 100%;position: relative;display: flex;flex-direction: column;">
		<div class="titleBar"
			style="display: flex;align-items:center ;position: sticky;top: 0;background: #202027;padding: 20px;padding-bottom: 14px;">
			<span style="width: 5px;height: 16px;background: #419FFF;margin-right:12px ;"></span>
			<p style="font-size: 16px;line-height: 22px;color: #F4F4F4;">
				{{$t('gongxubuliangfenxi')}}
			</p>
		</div>
    <div v-if="cockpitData.badQuantityRateData.length===0" style="display: flex;justify-content: center;align-items: center;margin-top: 45px">
      <span style="color: #909399;font-size: 16px">{{$t('zanwushuju')}}</span>
    </div>
		<div style="padding-bottom: 20px;display: flex;justify-content: space-between;flex: 1;">
			<div style="width:33.3%;display: flex;flex-direction: column;align-items: center;justify-content: center;">
				<template v-if="cockpitData.badQuantityRateData[0]">
					<p style="font-size:16px;color:white;font-weight:600;text-align: center;margin-top:30px">
						{{ cockpitData.badQuantityRateData[0].badQuantityRate}}%
					</p>
					<img :src="require('@@/assets/img/web/cockpit/gongxu_2.png')" style="width: 78%;height: auto" />
					<p style="font-size:14px;color:#C0C4CC;text-align: center;margin-top:4px">
						{{cockpitData.badQuantityRateData[0].procedureDesc}}
					</p>
				</template>
			</div>
			<div v-if="cockpitData.badQuantityRateData[1]"
				style="width:33.3%;display: flex;flex-direction: column;align-items: center;justify-content: center;">
				<template v-if="cockpitData.badQuantityRateData[1]">
					<p style="font-size:16px;color:white;font-weight:600;text-align: center;margin-top:0px">
						{{ cockpitData.badQuantityRateData[1].badQuantityRate}}%
					</p>
					<img :src="require('@@/assets/img/web/cockpit/gongxu_1.png')" style="width: 78%;height: auto" />
					<p style="font-size:14px;color:#C0C4CC;text-align: center;margin-top:4px">
						{{cockpitData.badQuantityRateData[1].procedureDesc}}
					</p>
				</template>
			</div>
			<div style="width:33.3%;display: flex;flex-direction: column;align-items: center;justify-content: center;">
				<template v-if="cockpitData.badQuantityRateData[2]">
					<p style="font-size:16px;color:white;font-weight:600;text-align: center;margin-top:30px">
						{{ cockpitData.badQuantityRateData[2].badQuantityRate}}%
					</p>
					<img :src="require('@@/assets/img/web/cockpit/gongxu_3.png')" style="width: 78%;height: auto" />
					<p style="font-size:14px;color:#C0C4CC;text-align: center;margin-top:4px">
						{{cockpitData.badQuantityRateData[2].procedureDesc}}
					</p>
				</template>

			</div>

		</div>
	</div>

</template>
<script type="text/javascript">
	export default {
		name: 'web_monitor_cockpit_flow_sort',
		components: {

		},
		props: {
			cockpitData: {
				type: Object,
				default: function() {
					return {}
				},
			},
		},
		data() {
			return {};
		},
		created() {

		},
		mounted() {
			this.resize()
			this.utils.event_hub.$on('RESIZE', () => {
				this.resize();
			});
		},
		watch: {

		},
		destroyed() {
			clearInterval(this.timmer)
		},
		methods: {

			resize() {
				//因为内容高度也是延迟计算的，这里必须设置延迟比外面Index更延迟
				setTimeout(() => {

				}, 500)

			},
		}
	};
</script>
